import Instance from '../../../Axios';

const RemoverMenu = (id) => async (dispatch) => {
  console.log(id);
  await Instance()
    .delete(`/backend/menus/${id}`)
    .then(({ data }) => {
      dispatch({ type: 'DELETE_MENU', payload: data });
    })
    .catch(({ err }) => console.log(err));
};

export default RemoverMenu;
